import React from "react";
import { Icons, Box, Stack } from "@curves/ui-base";

/**
 * 商品資訊組件
 * 用於顯示商品的基本資訊，支持編輯模式
 * @param {Object} props
 * @param {Object} props.product - 商品資訊
 * @param {boolean} props.showEditIcon - 是否顯示編輯圖標
 * @param {Function} props.onEdit - 編輯回調函數
 * @param {string} props.className - 自定義樣式類名
 */
const ProductInfo = ({ product, showEditIcon = false, onEdit, className = "" }) => {
	if (!product) {
		return null;
	}

	const { sku, name, spec, fixedPrice, currentPrice } = product;

	return (
		<Box className="product-info">
			<Box className="product-info-sku">{sku}</Box>
			<Box className="product-info-name">{name}</Box>
			<Box className="product-info-specification">規格:{spec}</Box>

			<Stack className="product-info-price" spacing={1} justifyContent="start" alignItems="center">
				<Stack spacing={1} alignItems="center">
					<Box className="product-info-current-price">${currentPrice}</Box>
					{showEditIcon && <Icons.Edit className={"text-secondary"} fontSize="small" />}
				</Stack>
				{fixedPrice && <Box className="product-info-original-price">定價 ${fixedPrice}</Box>}
			</Stack>
		</Box>
	);
};

export default ProductInfo;
